export default __webpack_public_path__ + "static/media/ic_upload.ea783286.svg";